// Top 100 countries by population (2024 estimates)
export const COUNTRIES = [
  'United States',
  'India',
  'China',
  'Indonesia',
  'Pakistan',
  'Brazil',
  'Bangladesh',
  'Nigeria',
  'Russia',
  'Mexico',
  'Japan',
  'Philippines',
  'Ethiopia',
  'Egypt',
  'Vietnam',
  'DR Congo',
  'Iran',
  'Turkey',
  'Germany',
  'Thailand',
  'United Kingdom',
  'France',
  'Italy',
  'Tanzania',
  'South Africa',
  'Myanmar',
  'Kenya',
  'South Korea',
  'Colombia',
  'Spain',
  'Uganda',
  'Argentina',
  'Sudan',
  'Algeria',
  'Iraq',
  'Afghanistan',
  'Poland',
  'Canada',
  'Morocco',
  'Saudi Arabia',
  'Ukraine',
  'Angola',
  'Uzbekistan',
  'Yemen',
  'Peru',
  'Malaysia',
  'Ghana',
  'Mozambique',
  'Nepal',
  'Madagascar',
  'Venezuela',
  'Cameroon',
  'Ivory Coast',
  'North Korea',
  'Australia',
  'Niger',
  'Sri Lanka',
  'Burkina Faso',
  'Mali',
  'Romania',
  'Malawi',
  'Chile',
  'Kazakhstan',
  'Zambia',
  'Guatemala',
  'Ecuador',
  'Syria',
  'Netherlands',
  'Senegal',
  'Cambodia',
  'Chad',
  'Somalia',
  'Zimbabwe',
  'Guinea',
  'Rwanda',
  'Benin',
  'Burundi',
  'Tunisia',
  'Bolivia',
  'Belgium',
  'Haiti',
  'Cuba',
  'South Sudan',
  'Dominican Republic',
  'Czech Republic',
  'Greece',
  'Jordan',
  'Portugal',
  'Azerbaijan',
  'Sweden',
  'Honduras',
  'United Arab Emirates',
  'Hungary',
  'Tajikistan',
  'Belarus',
  'Austria',
  'Papua New Guinea',
  'Serbia',
  'Israel',
  'Switzerland',
  'Togo',
  'Sierra Leone',
  'Laos',
  'Paraguay',
  'Bulgaria',
  'Libya',
  'Lebanon',
  'Nicaragua',
  'Kyrgyzstan',
  'El Salvador',
  'Turkmenistan',
  'Singapore',
  'Denmark',
  'Finland',
  'Congo',
  'Slovakia',
  'Norway',
  'Eritrea',
  'Palestine',
  'Oman',
  'Liberia',
  'Ireland',
  'New Zealand',
  'Central African Republic',
  'Mauritania',
  'Panama',
  'Kuwait',
  'Croatia',
  'Moldova',
  'Georgia',
  'Uruguay',
  'Bosnia and Herzegovina',
  'Albania',
  'Qatar',
  'Jamaica',
  'Armenia',
  'Lithuania',
  'Gambia',
  'Botswana',
  'Namibia',
  'Gabon',
  'Lesotho',
  'Slovenia',
  'Guinea-Bissau',
  'Latvia',
  'Bahrain',
  'Equatorial Guinea',
  'Trinidad and Tobago',
  'Estonia',
  'East Timor',
  'Mauritius',
  'Cyprus',
  'Eswatini',
  'Djibouti',
  'Fiji',
  'Comoros',
  'Guyana',
  'Bhutan',
  'Solomon Islands',
  'Macau',
  'Montenegro',
  'Luxembourg',
  'Suriname',
  'Malta',
  'Maldives',
  'Brunei',
  'Belize',
  'Bahamas',
  'Iceland',
  'Vanuatu',
  'Barbados',
  'New Caledonia',
  'French Polynesia',
  'Sao Tome and Principe',
  'Samoa',
  'Saint Lucia',
  'Channel Islands',
  'Guam',
  'Curacao',
  'Kiribati',
  'Micronesia',
  'Grenada',
  'Saint Vincent and the Grenadines',
  'Aruba',
  'Tonga',
  'U.S. Virgin Islands',
  'Antigua and Barbuda',
  'Seychelles',
  'Isle of Man',
  'Andorra',
  'Dominica',
  'Cayman Islands',
  'Bermuda',
  'Greenland',
  'Marshall Islands',
  'Northern Mariana Islands',
  'American Samoa',
  'Saint Kitts and Nevis',
  'Faroe Islands',
  'Sint Maarten',
  'Monaco',
  'Turks and Caicos Islands',
  'Liechtenstein',
  'San Marino',
  'Gibraltar',
  'British Virgin Islands',
  'Caribbean Netherlands',
  'Palau',
  'Cook Islands',
  'Anguilla',
  'Tuvalu',
  'Wallis and Futuna',
  'Nauru',
  'Saint Helena',
  'Saint Pierre and Miquelon',
  'Montserrat',
  'Falkland Islands',
  'Niue',
  'Tokelau',
  'Holy See'
];

// Helper function to check if a country is the United States
export const isUnitedStates = (country) => {
  return country && country.toLowerCase() === 'united states';
};

// Helper function to get countries matching a search term
export const getCountriesForSearch = (searchTerm) => {
  if (!searchTerm || searchTerm.length < 1) {
    return [];
  }
  const search = searchTerm.toLowerCase();
  return COUNTRIES
    .filter(country => country.toLowerCase().includes(search))
    .slice(0, 10); // Limit to 10 suggestions
};
